import React from 'react'
import { createContext } from 'use-context-selector'
import { useAppContextState } from 'app/@hooks'

const Context = createContext({})

const initialState = {
    // Raw evolution data: [{date, total:{hotelKey:price}, night:{hotelKey:price}}]
    evolutionData: null,
    // [{dataKey, label}] for matching hotel names
    hotelsKeys: null,
    // The extraction date string selected by the user as baseline
    selectedExtraction: null,
    // Loading states
    isEvolutionLoading: false,
}

export function CompetitionAnalyzerPriceComparisonProvider({ children }) {
    const { state, updateState } = useAppContextState(initialState)
    return <Context.Provider value={{ state, updateState }}>
        {children}
    </Context.Provider>
}

export default Context
